const features = [
  {
    icon: 'ri-download-cloud-2-line',
    title: '免费在线观看与下载',
    desc: '51动漫官网所有动漫资源均支持免费在线播放和高速下载，无需付费订阅，动漫全集即点即看、即下即存，让追番零门槛。',
  },
  {
    icon: 'ri-file-text-line',
    title: '下拉式连续追更',
    desc: '独创下拉式追更模式，滚动页面即可自动加载下一集或下一话，告别频繁翻页的烦恼，带来沉浸式的动漫在线观看体验。',
  },
  {
    icon: 'ri-global-line',
    title: '日漫国漫韩漫全覆盖',
    desc: '51动漫官网同步收录日漫新番、国漫精品和韩漫热作，每天更新 50+ 集新内容，动漫类型涵盖热血、恋爱、奇幻、搞笑等八大类。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-4">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-[480px] mx-auto">
          为什么数百万漫友选择51动漫官网作为追番首选平台
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-100/80 rounded-xl p-6 md:p-7 text-center hover:bg-background-100 transition-colors duration-200"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-50 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}